export const GET_REVENUE_URL = '/revenue';
